// React
import React, { Component } from 'react';
import { connect } from 'react-redux';
// Routing
import { withRouter } from 'react-router-dom';
// Material
import {
  CircularProgress, Divider, FormControl, Select, MenuItem,
} from '@material-ui/core';
// Vendor
import {
  showNotify,
  updateLimitsIntegrations,
} from 'vendor/application/disptach';
// Infrastructure
import { IntegrationsAPI } from 'api/application/Integrations';
// Application
import { getZendeskFullBody } from 'vendor/application';
import { ElementsHandleAPI } from 'vendor/application/handleMethods';
// Translations
import { withTranslation } from 'react-i18next';
// Components
import { ElementsCustom } from '@components/Elements';
import { Button } from '@components/Input';
import './auth-method.scss';
// SVG
import { channelsSvg } from 'assets';
import { arrowRightSvg } from '@assets';

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      zendesk: getZendeskFullBody(),
      domain: '.zendesk.com',
      set_tag: '',
      oauth_subdomain: '',
      oauth_linked: false,
      oauth_connections: [],
      auth_type: 'oauth',
      oauth_token_hint: '',
    };
  }

  componentDidMount = () => {
    this.handleOauthReturn();
    this.getOauthStatus();
  };

  getOauthStatus = async () => {
    const { access, user } = this.props.data;

    try {
      const obj = new IntegrationsAPI(user.account_id, access, this.props);
      const status = await obj.get_zendesk_full_oauth_status();

      const connections = status.connections || [];
      const { oauth_subdomain, zendesk } = this.state;
      const subdomain = oauth_subdomain || zendesk.info.subdomain || status.oauth_subdomain || '';
      this.setState({ oauth_connections: connections }, () => {
        if (this.state.auth_type === 'oauth') {
          this.selectOauthSubdomain(subdomain);
        }
      });
    } catch (err) {
      // An unavailable status must not block the creation form or overwrite a
      // successful OAuth callback restored from local state.
    }
  };

  // Restore state after coming back from the Zendesk OAuth callback: the token
  // is already stored account-level, so mark the channel to be created as oauth.
  handleOauthReturn = () => {
    const params = new URLSearchParams(this.props.location.search);
    const result = params.get('oauth');
    if (!result) {
      return;
    }

    if (result === 'success') {
      const { zendesk } = this.state;
      const subdomain = window.localStorage.getItem('zd_oauth_subdomain') || '';
      zendesk.info.subdomain = subdomain;
      this.setState({
        zendesk,
        oauth_subdomain: subdomain,
        oauth_linked: true,
        auth_type: 'oauth',
      });
    } else {
      this.props.dispatch(
        showNotify({
          message: 'integration_zendesk_oauth_error',
          severity: 'error',
        }),
      );
    }

    window.localStorage.removeItem('zd_oauth_subdomain');
    this.props.history.replace(this.props.location.pathname);
  };

  selectOauthSubdomain = (value) => {
    const subdomain = (value || '').trim().toLowerCase().replace(/\.zendesk\.com$/, '');
    this.setState(({ zendesk, oauth_connections }) => ({
      oauth_subdomain: subdomain,
      zendesk: { ...zendesk, info: { ...zendesk.info, subdomain } },
      oauth_linked: oauth_connections.some((item) => item.subdomain === subdomain),
      oauth_token_hint: '',
    }));
  };

  handleOauthSubdomain = (e) => {
    this.selectOauthSubdomain(e.target.value);
  };

  getOauthAuthorizationUrl = () => {
    const { oauth_subdomain } = this.state;
    const { actualProject, user } = this.props.data;
    // No channel_id yet: the callback stores the token and returns to this
    // create page, where the channel is then created with auth_type='oauth'.
    const state = window.btoa(
      JSON.stringify({
        target: 'zendesk_full',
        account_id: user.account_id,
        project_id: actualProject.id,
        subdomain: oauth_subdomain,
      }),
    );
    const params = new URLSearchParams({
      response_type: 'code',
      expires_in: '1800',
      client_id: process.env.REACT_APP_ZENDESK_CLIENT_ID,
      redirect_uri: process.env.REACT_APP_ZENDESK_REDIRECT_URI,
      scope: process.env.REACT_APP_ZENDESK_SCOPE.replace(/\+/g, ' '),
      state: state,
    });
    return `https://${oauth_subdomain}.zendesk.com/oauth/authorizations/new?${params.toString()}`;
  };

  vincularOauth = () => {
    const { oauth_subdomain } = this.state;
    if (!oauth_subdomain) {
      return;
    }
    // Persist the subdomain so it survives the redirect round-trip.
    window.localStorage.setItem('zd_oauth_subdomain', oauth_subdomain);
    window.location.href = this.getOauthAuthorizationUrl();
  };

  // update element state
  updateElement = (e, type, i) => {
    if (type === 'subdomain' && this.state.auth_type === 'oauth') {
      this.selectOauthSubdomain(e.target.value);
      return;
    }
    const { zendesk } = this.state;
    const obj = new ElementsHandleAPI(zendesk.info, e.target.value, type, i);
    obj.updateObj();

    this.setState({ zendesk: zendesk });
  };

  postIntegration = async (e) => {
    e.preventDefault();
    const { access, actualProject } = this.props.data;
    const { history } = this.props;
    const { zendesk, domain } = this.state;
    const { oauth_linked, auth_type } = this.state;
    if (auth_type === 'oauth' && !oauth_linked) {
      return;
    }
    zendesk.info.subdomain =
      zendesk.info.subdomain.replace('.zendesk.com', '') + domain;

    // A linked OAuth credential is the authentication source for new channels.
    // Do not persist stale basic credentials that may have been entered before
    // the OAuth redirect completed.
    zendesk.info.auth_type = auth_type;
    if (auth_type === 'oauth') {
      zendesk.info.email = '';
      zendesk.info.token = '';
    }
    try {
      const obj = new IntegrationsAPI(
        actualProject.id,
        access,
        this.props,
        zendesk,
      );
      let integration = await obj.post_integration();
      this.props.dispatch(
        showNotify({
          message: 'integrations',
          type: 'create',
          severity: 'success',
        }),
      );

      this.props.data.limitsIntegrations.zendesk_full.existIntegration = true;
      this.props.dispatch(
        updateLimitsIntegrations(this.props.data.limitsIntegrations),
      );

      history.push(
        `/${actualProject.id}/integrations/zendesk_full/edit/${integration.id}`,
      );
    } catch (err) {
      zendesk.info.subdomain = zendesk.info.subdomain.replace(
        '.zendesk.com',
        '',
      );
      this.props.dispatch(showNotify({ message: err, severity: 'error' }));
    }
  };

  handleTags = (e, type, elementType, chipToDelete, i) => {
    var { zendesk, set_tag } = this.state;
    var element_to_update;

    switch (elementType) {
      case 'tags':
        element_to_update = zendesk.info.tags;
        break;
    }

    var tag = e.target.value;
    switch (type) {
      case 'add':
        if (tag.match(/^[a-zA-Z0-9_\/]*$/)) {
          set_tag = tag;
          this.setState({ set_tag: set_tag });
        }
        break;
      case 'delete':
        element_to_update.forEach((el) => {
          if (el === chipToDelete) {
            element_to_update.splice(i, 1);
          }
        });
        this.setState({ zendesk: zendesk });
        break;
      case 'enter':
        element_to_update.push(tag);
        set_tag = '';
        this.setState({ zendesk: zendesk, set_tag: set_tag });
        break;
    }
  };

  handleSortSelect = (e) => {
    const { zendesk } = this.state;
    if (e) {
      zendesk.info.sort_messages = e;
      this.setState({ zendesk: zendesk });
    }
  };

  return = () => {
    const { history } = this.props;
    const { actualProject } = this.props.data;
    history.push(`/${actualProject.id}/integrations/zendesk_full`);
  };

  render() {
    const {
      zendesk,
      set_tag,
      oauth_subdomain,
      oauth_linked,
      oauth_token_hint,
      auth_type,
    } = this.state;
    const { t } = this.props;
    const { isSending } = this.props.data;
    return (
      zendesk && (
        <React.Fragment>
          <div className={'cen_integrations'}>
            <div className={'header'}>
              <div className={'header_content'}>
                <div onClick={() => this.return()} className={'header_action'}>
                  {arrowRightSvg()}
                </div>
                <div className={'header_image'}>
                  {channelsSvg('zendesk_full')}
                </div>
                <div className={'header_title'}>
                  <span className={'title'}>
                    {t('integrations:channels.zendesk_full.title')}
                  </span>
                  <span className={'description'}>
                    {t('integrations:categories.business')}
                  </span>
                </div>
              </div>
              <div className={'header_actions'}>
                {isSending ? (
                  <Button
                    type={'primary'}
                    disabled
                    text={<CircularProgress size={21} />}
                  />
                ) : (
                  <Button
                    type={'primary'}
                    text={t('integrations:create.action_button')}
                    disabled={auth_type === 'oauth' && !oauth_linked}
                    onClick={(e) => this.postIntegration(e)}
                  />
                )}
              </div>
            </div>
            <div className={'integration'}>
              <div className="zendesk-auth-method">
                <div className="elements_custom">
                  <div className="elements_custom__info">
                    <label id="zendesk-auth-label" className="elements_custom__title">
                      {t('integrations:channels.zendesk_full.auth_method')}
                    </label>
                  </div>
                  <FormControl className="zendesk-auth-method__control" fullWidth variant="outlined" size="small">
                    <Select
                      labelId="zendesk-auth-label"
                      id="zendesk-auth-method"
                      value={auth_type}
                      onChange={(e) => {
                        const auth_type = e.target.value;
                        this.setState({ auth_type }, () => {
                          if (auth_type === 'oauth') {
                            this.selectOauthSubdomain(this.state.zendesk.info.subdomain);
                          }
                        });
                      }}
                      inputProps={{
                        'aria-describedby': auth_type === 'basic' ? 'zendesk-auth-notice' : undefined,
                      }}
                    >
                      <MenuItem value="oauth">OAuth</MenuItem>
                      <MenuItem value="basic">API token</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                {auth_type === 'basic' && (
                  <p id="zendesk-auth-notice" className="zendesk-auth-method__notice">
                    {t('integrations:channels.zendesk_full.legacy_auth_notice')}
                  </p>
                )}
              </div>
              <Divider />
              {/* NAME */}
              <ElementsCustom
                t={t}
                type={'zendesk'}
                input_type={'input'}
                element_type={'name'}
                element={zendesk.name}
                updateElement={(e) => {
                  zendesk.name = e.target.value;
                  this.setState({ zendesk });
                }}
              />
              <Divider />
              {/* SUBDOMAIN */}
              <ElementsCustom
                t={t}
                type={'zendesk'}
                input_type={'input_zendesk'}
                element_type={'subdomain'}
                element={zendesk.info.subdomain.replace('.zendesk.com', '')}
                updateElement={this.updateElement}
              />
              <Divider />
              {/* EMAIL + TOKEN: only required for basic authentication */}
              {auth_type === 'basic' && (
                <React.Fragment>
                  <ElementsCustom
                    t={t}
                    type={'zendesk'}
                    input_type={'input'}
                    element_type={'email'}
                    element={zendesk.info.email}
                    updateElement={this.updateElement}
                  />
                  <Divider />
                  <ElementsCustom
                    t={t}
                    type={'zendesk'}
                    input_type={'input'}
                    element_type={'token'}
                    element={zendesk.info.token}
                    updateElement={this.updateElement}
                  />
                  <Divider />
                </React.Fragment>
              )}
              {/* TICKET SUBJECT */}
              <ElementsCustom
                t={t}
                type={'zendesk'}
                input_type={'input'}
                element_type={'subject'}
                element={zendesk.info.subject}
                updateElement={this.updateElement}
              />
              <Divider />
              {/* SORT MESSAGES */}
              <ElementsCustom
                t={t}
                type={'zendesk'}
                input_type={'select'}
                element_type={'sort_messages'}
                select_value={''}
                element={t(
                  `elements.custom.zendesk.card.sort_messages.${zendesk.info.sort_messages}`,
                )}
                elements={['asc', 'desc']}
                updateElement={this.handleSortSelect}
              />
              <Divider />
              {/* TAGS */}
              <ElementsCustom
                t={t}
                type={'zendesk'}
                input_type={'input_with_tags'}
                element_type={'tags'}
                element={set_tag}
                elements={zendesk.info.tags}
                updateElement={this.handleTags}
              />
              <Divider />
              {/* ZENDESK CUSTOM FIELD */}
              <ElementsCustom
                t={t}
                type={'zendesk'}
                input_type={'switch'}
                element_type={'use_custom_fields'}
                element={zendesk.info.use_custom_fields}
                updateElement={this.updateElement}
              />
            </div>
          </div>
          {/* OAUTH */}
          {auth_type === 'oauth' && (
            <div className={'cen_integrations'}>
              <div className={'header'}>
                <div className={'header_content'}>
                  <div className={'header_title'}>
                    <span className={'title'}>
                      {t('integrations:channels.zendesk_full.oauth.title')}
                    </span>
                    {oauth_linked ? (
                      <span className={'description'}>
                        <span
                          className={'status active'}
                          style={{
                            background: '#2ecc71',
                            color: '#fff',
                            padding: '2px 10px',
                            borderRadius: '12px',
                            fontWeight: 500,
                          }}
                        >
                          {t(
                            'integrations:channels.zendesk_full.oauth.configured',
                          )}
                        </span>
                        {oauth_token_hint &&
                          ` · ${t(
                            'integrations:channels.zendesk_full.oauth.token_hint',
                          )} ••••${oauth_token_hint}`}
                      </span>
                    ) : (
                      <span className={'description'}>
                        {t(
                          'integrations:channels.zendesk_full.oauth.description',
                        )}
                      </span>
                    )}
                  </div>
                </div>
                <div className={'header_actions'}>
                  <Button
                    type={'primary'}
                    disabled={!oauth_subdomain}
                    text={t(
                      oauth_linked
                        ? 'integrations:channels.zendesk_full.oauth.update_button'
                        : 'integrations:channels.zendesk_full.oauth.action_button',
                    )}
                    onClick={() => this.vincularOauth()}
                  />
                </div>
              </div>
              <div className={'integration'}>
                {this.state.oauth_connections.length > 0 && (
                  <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 16 }}>
                    <Select
                      displayEmpty
                      value={oauth_linked ? oauth_subdomain : ''}
                      onChange={(e) => this.selectOauthSubdomain(e.target.value)}
                      inputProps={{ 'aria-label': t('integrations:channels.zendesk_full.oauth.reuse_button') }}
                    >
                      <MenuItem value="">{t('integrations:channels.zendesk_full.oauth.action_button')}</MenuItem>
                      {this.state.oauth_connections.map(({ subdomain }) => (
                        <MenuItem key={subdomain} value={subdomain}>{subdomain}.zendesk.com</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                <ElementsCustom
                  t={t}
                  type={'zendesk'}
                  input_type={'input_zendesk'}
                  element_type={'subdomain'}
                  element={oauth_subdomain}
                  updateElement={this.handleOauthSubdomain}
                />
              </div>
            </div>
          )}
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state,
  };
};

const create = connect(mapStateToProps)(Create);

export default withTranslation(['commons', 'common', 'integrations'])(
  withRouter(create),
);
